<tr [class.text-muted]="userBonus.status !== 'ACTIVE'">
  <td class="table-column">
    <div class="d-flex align-items-center">
      <div class="d-flex justify-content-start flex-column">
        <span class="text-dark fw-bolder fs-6 text-truncate mw-200px">
          {{ userBonus.title }}
        </span>
        <span class="text-muted fw-bold d-block fs-7 text-truncate mw-200px" *ngIf="userBonus.description">
          {{ userBonus.description }}
        </span>
      </div>
    </div>
  </td>
  <td class="table-column">
    <ng-container [ngSwitch]="userBonus.status">
      <span *ngSwitchCase="'ACTIVE'" class="badge badge-light-success fs-7 fw-bold">
        {{ 'WL_BONUSES.FILTER.ACTIVE' | translate }}
      </span>
      <span *ngSwitchCase="'EXPIRED'" class="badge badge-light-warning fs-7 fw-bold">
        {{ 'WL_BONUSES.FILTER.EXPIRED' | translate }}
      </span>
      <span *ngSwitchCase="'DELETED'" class="badge badge-light-danger fs-7 fw-bold">
        {{ 'WL_BONUSES.FILTER.DELETED' | translate }}
      </span>
      <span *ngSwitchDefault class="badge badge-light-info fs-7 fw-bold">
        {{ userBonus.status }}
      </span>
    </ng-container>
  </td>
  <td class="table-column">{{ userBonus.expireDate }}</td>
  <td class="table-column">{{ userBonus.amount | appCurrency}}</td>
  <td [class.fw-bold]="userBonus.balance > 0">
    {{ userBonus.balance | appCurrency }}
  </td>
  <td class="text-center">
    <ng-container *ngIf="userBonus.docsUrl">
      <a [href]="userBonus.docsUrl" target="_blank" title="View Document">
        <span
          [inlineSVG]="'./assets/media/icons/duotune/general/gen005.svg'"
          class="svg-icon svg-icon-3"
          [ngClass]="{'text-primary': userBonus.status === 'ACTIVE'}"
        ></span>
      </a>
    </ng-container>
  </td>
</tr>
